export const acetal1 = require('./acetal1.png');
export const addbenring1 = require('./addbenring1.png');
export const addbenring2 = require('./addbenring2.png');
export const addbenring3 = require('./addbenring3.png');
export const addbenring4 = require('./addbenring4.png');
export const addbenring5 = require('./addbenring5.png');
export const addbenring6 = require('./addbenring6.png');
export const addhalo1 = require('./addhalo1.png');
export const addhalo2 = require('./addhalo2.png');
export const addhalo3 = require('./addhalo3.png');
export const addhalo4 = require('./addhalo4.png');
export const addhalo5 = require('./addhalo5.png');
export const addhalo6 = require('./addhalo6.png');
export const addhalo7 = require('./addhalo7.png');
export const addhalo8 = require('./addhalo8.png');
export const addhalo9 = require('./addhalo9.png');
export const addhalo10 = require('./addhalo10.png');
export const alcohol1 = require('./alcohol1.png');
export const alcohol2 = require('./alcohol2.png');
export const alcohol3 = require('./alcohol3.png');
export const alcohol4 = require('./alcohol4.png');
export const alcohol6 = require('./alcohol6.png');
export const alcohol7 = require('./alcohol7.png');
export const alcohol8 = require('./alcohol8.png');
export const alcohol9 = require('./alcohol9.png');
export const alcohol10 = require('./alcohol10.png');
export const alcohol11 = require('./alcohol11.png');
export const alcohol12 = require('./alcohol12.png');
export const alcohol13 = require('./alcohol13.png');
export const alcohol14 = require('./alcohol14.png');
export const aldehyde1 = require('./aldehyde1.png');
export const aldehyde2 = require('./aldehyde2.png');
export const aldehyde3 = require('./aldehyde3.png');
export const aldehyde4 = require('./aldehyde4.png');
export const aldehyde5 = require('./aldehyde5.png');
export const alkane1 = require('./alkane1.png');
export const alkane2 = require('./alkane2.png');
export const alkene1 = require('./alkene1.png');
export const alkene2 = require('./alkene2.png');
export const alkene3 = require('./alkene3.png');
export const alkene4 = require('./alkene4.png');
export const alkyne1 = require('./alkyne1.png');
export const amide1 = require('./amide1.png');
export const amide2 = require('./amide2.png');
export const amide3 = require('./amide3.png');
export const carboxy1 = require('./carboxy1.png');
export const carboxy2 = require('./carboxy2.png');
export const carboxy3 = require('./carboxy3.png');
export const carboxy4 = require('./carboxy4.png');
export const carboxy5 = require('./carboxy5.png');
export const carboxy6 = require('./carboxy6.png');
export const ccbond1 = require('./ccbond1.png');
export const ccbond2 = require('./ccbond2.png');
export const ccbond3 = require('./ccbond3.png');
export const ccbond4 = require('./ccbond4.png');
export const ccbond5 = require('./ccbond5.png');
export const ccbond6 = require('./ccbond6.png');
export const ccbond7 = require('./ccbond7.png');
export const ccbond8 = require('./ccbond8.png');
export const deoxy1 = require('./deoxy1.png');
export const deoxy2 = require('./deoxy2.png');
export const deoxy3 = require('./deoxy3.png');
export const deoxy4 = require('./deoxy4.png');
export const epoxide1 = require('./epoxide1.png');
export const epoxide2 = require('./epoxide2.png');
export const epoxide3 = require('./epoxide3.png');
export const ether1 = require('./ether1.png');
export const ether2 = require('./ether2.png');
export const ether3 = require('./ether3.png');
export const ester1 = require('./ester1.png');
export const ester2 = require('./ester2.png');
export const ester3 = require('./ester3.png');
export const imine1 = require('./imine1.png');
export const ketone1 = require('./ketone1.png');
export const ketone2 = require('./ketone2.png');
export const ketone3 = require('./ketone3.png');
export const ketone4 = require('./ketone4.png');
export const ketone5 = require('./ketone5.png');
export const ketone6 = require('./ketone6.png');
export const ketone7 = require('./ketone7.png');
export const ring1 = require('./ring1.png');
export const taut1 = require('./taut1.png');
export const taut2 = require('./taut2.png');
export const benzene = require('./benzene_ring.png');

























